// extracted by mini-css-extract-plugin
module.exports = {"info":"info__3vyo8","value":"value__jlpNe"};